module.exports = __webpack_public_path__ + "static/media/favicon.129fb6ee.ico";